import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="policy-page">
      <Header />
      <div className="policy-container">
        <h1 className="policy-title">Shipping & Delivery</h1>
        <p className="policy-date">Last updated: April 2026</p>

        <div className="policy-content">
          <section className="policy-section">
            <h3 className="section-title">1. Domestic Shipping</h3>
            <p className="section-text">
              We offer fast and reliable shipping for all domestic orders within
              the United States. All orders are carefully packaged to ensure
              your Liiskerlane products arrive in perfect condition.
            </p>
            <ul className="section-list">
              <li>
                <strong>Standard Shipping:</strong> 5-7 business days ($10.00)
              </li>
              <li>
                <strong>Express Shipping:</strong> 2-3 business days ($25.00)
              </li>
              <li>
                <strong>Overnight Shipping:</strong> Next business day ($50.00)
              </li>
            </ul>
            <p className="section-text">
              Orders are typically processed within 2-3 business days before
              being shipped. Processing time does not include weekends or
              holidays.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">2. International Shipping</h3>
            <p className="section-text">
              We ship worldwide! International orders are subject to customs
              duties and taxes, which are the responsibility of the recipient.
              Delivery times vary by destination:
            </p>
            <ul className="section-list">
              <li>
                <strong>Canada:</strong> 7-14 business days
              </li>
              <li>
                <strong>Europe:</strong> 10-21 business days
              </li>
              <li>
                <strong>Australia:</strong> 14-28 business days
              </li>
              <li>
                <strong>Other Destinations:</strong> 14-35 business days
              </li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">3. Tracking Your Order</h3>
            <p className="section-text">
              Once your order has been shipped, you will receive an email with a
              tracking number and a link to track your package. You can use this
              tracking number to monitor the status of your delivery in
              real-time.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">4. Shipping Delays</h3>
            <p className="section-text">
              While we strive to ship all orders on time, unforeseen
              circumstances such as weather, natural disasters, or carrier
              delays may occasionally affect delivery times. We will keep you
              informed of any significant delays.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">5. Lost or Damaged Packages</h3>
            <p className="section-text">
              If your package arrives damaged or goes missing, please contact us
              immediately at trade@liiskerlane.digital with your order number
              and tracking information. We will work with the carrier to resolve
              the issue and either send a replacement or issue a refund.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">6. Delivery Address</h3>
            <p className="section-text">
              Please ensure that your delivery address is accurate and complete.
              We are not responsible for packages delivered to incorrect
              addresses provided by the customer. If you need to change your
              address, please contact us before your order ships.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">7. Signature Requirements</h3>
            <p className="section-text">
              For certain high-value orders, a signature may be required upon
              delivery. Our shipping partners will make reasonable attempts to
              deliver your package. If no one is available to sign, the package
              will be held for pickup or redelivery.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">8. Shipping Costs</h3>
            <p className="section-text">
              Shipping costs are calculated based on the weight of your order
              and your delivery location. You will see the exact shipping cost
              during checkout before completing your purchase.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">9. Free Shipping</h3>
            <p className="section-text">
              We occasionally offer free shipping promotions. Check our website
              or sign up for our newsletter to stay informed about current
              shipping offers and discounts.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">10. Contact Us</h3>
            <p className="section-text">
              If you have questions about shipping or your delivery, please
              contact us:
            </p>
            <div className="contact-info">
              <p>
                <strong>Email:</strong> trade@liiskerlane.digital
              </p>

              <p>
                <strong>Hours:</strong> Monday - Friday, 9am - 5pm EST
              </p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Delivery;
